import React from "react";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useState } from "react";
import OryzaLogo from "./partials/images/icon/oryzalogo.png";
import PettiPettiLogo from "./partials/images/logo/pettipetti.png";
import KentLogo from "./partials/images/logo/kent.png";
import BBMLogo from "./partials/images/logo/bbmirissa.png";
import BBKLogo from "./partials/images/logo/bbkandy.png";
import SmallPetti from "./partials/images/logo/small_icons/petti.png";
import Smallkent from "./partials/images/logo/small_icons/kent.png";
import SmallBBK from "./partials/images/logo/small_icons/bbk.png";
import SmallBBM from "./partials/images/logo/small_icons/bbm.png";
import AnchorTemporaryDrawer from "./sidebar"
import "../oryza/partials/main.min.css";
import "../oryza/partials/bootstrap.min.css";
import "../oryza/partials/style.css";

export default function Oryzalandingpage() {
  const [activeCard, setActiveCard] = useState(1);

  const cards = [
    {
      id: 1,
      logo: PettiPettiLogo,
      link: "https://pettipettimirissa.com",
      image: SmallPetti,
      bgClass: "bgimage1",
    },
    {
      id: 2,
      logo: KentLogo,
      link: "https://kentcottagenuwaraeliya.com",
      image: Smallkent,
      bgClass: "bgimage2",
    },
    {
      id: 3,
      logo: BBKLogo,
      link: "https://bananabunkskandy.com",
      image: SmallBBK,
      bgClass: "bgimage3",
    },
    {
      id: 4,
      logo: BBMLogo,
      link: "https://bananabunksmirissa.com",
      image: SmallBBM,
      bgClass: "bgimage4",
    },
  ];

  return (
    <>
      <div className="header__content2">
        <div className="head-rapper">
          <div className="header__content-right2"></div>
          <div className="header-logo">
            <a href="/oryza/aboutus">
              <img src={OryzaLogo} alt="Oryza" className="logo" />
            </a>
          </div>
          <div className="header__content-right3">
            <span className="header-contact sidebar_set">
              <a
                className="tel"
                href="tel:+94767008800"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#fff" }}
              >
                Call us : + 94 76 700 8800
              </a>
            </span>
            <div className="header-social">
              <ul className="sidebar_set list-social list-social--light">
                <li className="list-social__item">
                  <a
                    className="ic-fb"
                    href="https://www.facebook.com/oryzaleisure/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FacebookIcon style={{ color: "white" }} />
                  </a>
                </li>
                <li className="list-social__item">
                  <a
                    className="ic-insta"
                    href="https://www.instagram.com/oryzaleisure/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <InstagramIcon style={{ color: "white" }} />
                  </a>
                </li>
                <li
                  className="list-social__item"
                  style={{ paddingRight: "10px" }}
                >
                  <a
                    className="ic-whatsapp"
                    href="https://wa.me/94767008800"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <WhatsAppIcon style={{ color: "white" }} />
                  </a>
                </li>
              </ul>
            </div>
            <AnchorTemporaryDrawer />
          </div>
        </div>
      </div>
      <section id="container">
        <div className="container1">
          <div className="options" style={{ lineHeight: "normal" }}>
            {cards.map((card) => (
              <div
                key={card.id}
                className={`option ${card.bgClass} ${
                  activeCard === card.id ? "active" : ""
                }`}
                onClick={() => setActiveCard(card.id)}
              >
                <div className="shadow"></div>
                <div className="label">
                  <div className="icon">
                    <img
                      src={card.logo}
                      style={{ maxWidth: "40px", maxHeight: "40px" }}
                      alt="logo"
                    />
                  </div>
                  <div className="info">
                    <a href={card.link}>
                      <img
                        className="largetileicon"
                        src={card.image}
                        alt="icon"
                      />
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
